import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Swal from "sweetalert2";
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LightGestion from 'components/headers/lightGestion';
import { Edit, Trash2 } from "lucide-react";

const GestionProduits = () => {
    const { i18n } = useTranslation();
    const { t } = useTranslation();
const [searchTerm, setSearchTerm] = useState("");
    const [products, setProducts] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [categories, setCategories] = useState([]);
    const [filterMode, setFilterMode] = useState('all'); // all | in | alert | out
    // admin type not needed here; we only check isAdmin below
    const [showModal, setShowModal] = useState(false);
    const [newProduct, setNewProduct] = useState({
        Name: { fr: '', ar: '' },
        barcode: '',
        purchase_price: '',
        retail_price: '', // single English field for 'prix détail'
        user_price: '',
        wholesale_price: '',
        carton_price: '',
        pieces_per_carton: '',
        StockQuantity: '',
        alert_threshold: '',
        Category: '',
        image: ''
    });

    const [editingProductId, setEditingProductId] = useState(null);
    const [loading, setLoading] = useState(false);

    // fetchAllProducts defined below (useCallback)

    // checkAdminStatus removed — logic handled in useEffect

    // Helper to safely parse JSON only if looks like JSON
    const parseIfJson = (str) => {
        if (typeof str !== 'string') return str;
        const trimmed = str.trim();
        if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
            try {
                return JSON.parse(trimmed);
            } catch {
                return str;
            }
        }
        return str;
    };

    const fetchAllProducts = useCallback(async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            const response = await axios.get(`  https://plateformewmg.cloud/api/Gestion/products?lang=${i18n.language}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const productsWithParsedFields = response.data.map(product => ({
                    ...product,
                    Name: parseIfJson(product.Name),
                    Description: parseIfJson(product.Description),
                }));
                setProducts(productsWithParsedFields);
            }
        } catch (error) {
            console.error(error);
        }
    }, [i18n.language]);
    console.log(products);

    // Helpers to normalize numeric fields across different backend key names
    const getFirst = (obj, keys) => {
        if (!obj) return undefined;
        for (const k of keys) {
            if (obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
        }
        return undefined;
    };

    const toNumber = (v) => {
        if (v === undefined || v === null || v === '') return NaN;
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : NaN;
    };

    const qtyOf = (p) => {
        const v = getFirst(p, ['StockQuantity', 'stock', 'StockQuantity', 'quantity']);
        const n = toNumber(v);
        return Number.isFinite(n) ? n : 0;
    };

    const thresholdOf = (p) => {
        const v = getFirst(p, ['alert_threshold', 'SeuilAlerte', 'AlertThreshold', 'seuil_alerte']);
        const n = toNumber(v);
        return Number.isFinite(n) ? n : 0;
    };

    // Precompute header counts so they reflect backend field variants
    const totalCount = products.length;
    const inStockCount = products.filter(p => qtyOf(p) > 0).length;
    const alertCount = products.filter(p => {
        const q = qtyOf(p);
        const t = thresholdOf(p);
        return q > 0 && t > 0 && q <= t;
    }).length;
    const outCount = products.filter(p => qtyOf(p) <= 0).length;

    // Helper to always display the French name (fallback to Arabic or raw string)
    const nameFr = (p) => {
        const n = p?.Name;
        if (n && typeof n === 'object') return n.fr || n.ar || '';
        return typeof n === 'string' ? n : '';
    };
    // (Category display helper removed for now since the list doesn't render a category column)

    useEffect(() => {
        const adminStatus = localStorage.getItem('isAdmin') === '1';
        const adminType = localStorage.getItem('admin_type') === 'gestion_stock';
        setIsAdmin(adminStatus);

        if (adminStatus && adminType) {
            fetchAllProducts();
        } else {
            console.error('Unauthorized: User is not an admin gestion stock');
        }
    }, [i18n.language, fetchAllProducts]);

    // fetch category options for admin (allow selecting existing category or typing a new one)
  async function fetchCategories() {
  try {
    const token = localStorage.getItem('authToken');
    const resp = await axios.get('https://plateformewmg.cloud/api/Gestion/category-admin-options', {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    if (resp.status === 200 && Array.isArray(resp.data.categories_admin)) {
      setCategories(resp.data.categories_admin);
    } else {
      console.error('Unexpected response structure:', resp.data);
    }
  } catch (e) {
    console.error('Failed to fetch category options', e);
  }
}

    useEffect(() => {
        fetchCategories();
    }, []);


const filtereProdcuts = products.filter(product => {
    const name = i18n.language === "ar" 
        ? (product.Name?.ar || product.Name?.fr || '') 
        : (product.Name?.fr || product.Name?.ar || '');

    if (!name.toLowerCase().includes(searchTerm.toLowerCase())) return false;

    const qty = Number(product.StockQuantity ?? product.stock ?? product.StockQuantity ?? 0);
    const threshold = Number(product.alert_threshold ?? product.SeuilAlerte ?? product.AlertThreshold ?? 0);

    switch (filterMode) {
        case 'in':
            return qty > 0;
        case 'alert':
            return qty > 0 && threshold > 0 && qty <= threshold;
        case 'out':
            return qty <= 0;
        default:
            return true;
    }
});

    const handleEdit = (productId) => {
  setEditingProductId(productId);
  const product = products.find(p => p.ID === productId);

    // Safely parse Name
    let parsedName = parseIfJson(product.Name);
  if (typeof parsedName !== "object") {
    parsedName = { fr: product.Name || '', ar: '' };
  }
        // helper to try many key variants and return first defined/non-empty
        const resolveField = (obj, keys) => {
            for (const k of keys) {
                if (obj == null) break;
                const val = obj[k];
                if (val !== undefined && val !== null && val !== '') return val;
            }
            return '';
        };

        const asString = (v) => (v === undefined || v === null ? '' : String(v));

        setNewProduct({
            Name: parsedName,
            // try known variants for each field so the modal shows values regardless of backend naming
            barcode: asString(resolveField(product, ['Ref', 'ref', 'Barcode', 'barcode', 'code_barre', 'codeBarre'])),
            purchase_price: asString(resolveField(product, ['purchase_price', 'PurchasePrice', 'prix_achat', 'prixAchat', 'PrixAchat'])),
            retail_price: asString(resolveField(product, ['retail_price', 'retailPrice', 'prix_detail', 'prixDetail', 'PrixDetail', 'user_price', 'UserPrice'])),
            user_price: asString(resolveField(product, ['user_price', 'UserPrice'])),
            wholesale_price: asString(resolveField(product, ['wholesale_price', 'wholesalePrice', 'distributeur_price', 'distributeurPrice', 'PrixGros', 'prix_gros'])),
            carton_price: asString(resolveField(product, ['carton_price', 'cartonPrice', 'prix_carton', 'PrixCarton'])),
            pieces_per_carton: asString(resolveField(product, ['pieces_per_carton', 'PiecesPerCarton', 'piecesParCarton', 'PiecesParCarton'])),
            StockQuantity: asString(resolveField(product, ['StockQuantity', 'stock', 'quantity'])),
            alert_threshold: asString(resolveField(product, ['alert_threshold', 'AlertThreshold', 'seuil_alerte', 'SeuilAlerte'])),
            Category: resolveField(product, ['Category', 'category']) || '',
            CategoryAdmin: asString(resolveField(product, ['Category', 'category'])) || '',
            image: resolveField(product, ['image', 'Image']) || ''
        });

  setShowModal(true);
};



    const handleDelete = async (productId) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            Swal.fire({
                title: 'Êtes-vous sûr?',
                text: "Vous ne pourrez pas revenir en arrière!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'Annuler'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await axios.delete(`  https://plateformewmg.cloud/api/Gestion/products/${productId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (response.status === 200) {
                        setProducts(products.filter(product => product.ID !== productId));
                        Swal.fire(
                            'Supprimé!',
                            'Le produit a été supprimé.',
                            'success'
                        );
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const handleShowModal = () => {
        setEditingProductId(null);
        setNewProduct({
            Name: { fr: '', ar: '' },
            barcode: '',
            purchase_price: '',
            retail_price: '',
            user_price: '',
            wholesale_price: '',
            carton_price: '',
            pieces_per_carton: '',
            StockQuantity: '',
            alert_threshold: '',
            CategoryAdmin: '',
            image: ''
        });
        // refresh category options when opening modal so newly added categories appear
        fetchCategories();
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    // generic handleChange removed (we use inline setters for clarity)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setLoading(false);
                return;
            }

            const formData = new FormData();
            // Append requested French-named fields for backend
            formData.append('Name', JSON.stringify(newProduct.Name));
            formData.append('barcode', newProduct.barcode);
            // English keys mapping (single canonical set)
            // Append both 'Category' and 'category' to satisfy backends with different expectations
            formData.append('CategoryAdmin', newProduct.CategoryAdmin);
            formData.append('purchase_price', newProduct.purchase_price);
            formData.append('retail_price', newProduct.retail_price || newProduct.user_price || '');
            formData.append('wholesale_price', newProduct.wholesale_price);
            formData.append('carton_price', newProduct.carton_price);
            formData.append('pieces_per_carton', newProduct.pieces_per_carton);
            formData.append('StockQuantity', newProduct.StockQuantity);
            formData.append('alert_threshold', newProduct.alert_threshold);

            if (newProduct.image instanceof File) {
                formData.append('image', newProduct.image);
            }

            let response;
            if (editingProductId) {
                response = await axios.post(
                    `  https://plateformewmg.cloud/api/Gestion/products/${editingProductId}?_method=PUT`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            } else {
                response = await axios.post(
                    '  https://plateformewmg.cloud/api/Gestion/products',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }

            if (response.status === 200 || response.status === 201) {
                fetchAllProducts();
                handleCloseModal();
                Swal.fire(
                    'Succès!',
                    `Le produit a été ${editingProductId ? 'modifié' : 'ajouté'} avec succès.`,
                    'success'
                );
            }
        } catch (error) {
            // Improved error logging to surface server response (helps debug 500 errors)
            console.error('Submit error', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                Swal.fire('Erreur serveur', error.response.data?.message || JSON.stringify(error.response.data), 'error');
            } else if (error.request) {
                console.error('No response received:', error.request);
                Swal.fire('Erreur réseau', 'Aucune réponse du serveur.', 'error');
            } else {
                Swal.fire('Erreur', error.message || 'Une erreur est survenue', 'error');
            }
        }
        setLoading(false);
    };
    if (!isAdmin) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Alert variant="danger" style={{ width: '80%', textAlign: 'center' }}>
                    Unauthorized: You do not have admin access.
                </Alert>
            </div>
        );
    }

    return (
        <AnimationRevealPage>
            <LightGestion />
            <div className="d-flex flex-column">
                <section className="w-100 " style={{ minHeight: '70vh' ,marginTop:"-50px"}}>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                            <h2 style={{ fontWeight: 900, fontSize: '30px', marginBottom: 6 }}>{t('produits_stock_title')}</h2>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: 14 }}>
                                <span style={{ color: '#4a90e2' }}>● {t('total_label')}: {totalCount}</span>
                                <span style={{ color: '#28a745' }}>● {t('in_stock_label')}: {inStockCount}</span>
                                <span style={{ color: '#ffc107' }}>● {t('alert_label')}: {alertCount}</span>
                                <span style={{ color: '#dc3545' }}>● {t('out_of_stock_label')}: {outCount}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                            <button className="btn" style={{ background: '#1e64f2', color: 'white', padding: '10px 28px', borderRadius: 10 ,marginRight:40}} onClick={handleShowModal}>{t('ajouter_un_produit')}</button>
                        </div>
                    </div>

                    <div style={{ background: 'white', padding: 18, borderRadius: 12, boxShadow: '0 6px 18px rgba(23, 42, 77, 0.05)' }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{ flex: 1, marginRight: 16 }}>
                                <div className="input-group" style={{ boxShadow: 'none' }}>
                                    <span className="input-group-text" style={{ background: 'white', borderRight: 'none' }}>
                                        🔍
                                    </span>
                                    <input type="text" className="form-control" placeholder={t('search_products_placeholder')} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button onClick={() => setFilterMode('all')} className={filterMode === 'all' ? 'btn' : 'btn btn-outline-secondary'} style={{ borderRadius: 8 }}>{t('filter_all')}</button>
                                <button onClick={() => setFilterMode('in')} className={filterMode === 'in' ? 'btn' : 'btn btn-outline-secondary'} style={{ borderRadius: 8 }}>{t('in_stock_label')}</button>
                                <button onClick={() => setFilterMode('alert')} className={filterMode === 'alert' ? 'btn' : 'btn btn-outline-secondary'} style={{ borderRadius: 8 }}>{t('alert_label')}</button>
                                <button onClick={() => setFilterMode('out')} className={filterMode === 'out' ? 'btn' : 'btn btn-outline-secondary'} style={{ borderRadius: 8 }}>{t('out_of_stock_label')}</button>
                            </div>
                        </div>

                        {/* Header row labels - use same flex/basis as the item rows so columns align */}
                        <div className="d-none d-md-flex" style={{ padding: '8px 8px', borderBottom: '1px solid #eef2f7', color: '#6b7280', fontSize: 13, alignItems: 'center' }}>
                            <div style={{ flex: '0 0 36px' }}></div>
                            <div style={{ flex: '1 1 120px' }}>{t('Nom')}</div>
                            <div style={{ flex: '0 0 110px' }}>{t('Code_barres')}</div>
                            <div style={{ flex: '0 0 120px', textAlign: 'center' }}>{t('Prix_Detail_short')}</div>
                            <div style={{ flex: '0 0 120px', textAlign: 'center' }}>{t('Prix_Gros_short')}</div>
                            <div style={{ flex: '0 0 90px', textAlign: 'center' }}>{t('Stock')}</div>
                            <div style={{ flex: '0 0 150px', textAlign: 'right' }}>{t('Actions')}</div>
                        </div>

                        <div style={{ marginTop: 12 }}>
                                {filtereProdcuts.map((product) => (
                                <div key={product.ID} className="d-flex align-items-center flex-md-nowrap flex-wrap" style={{ background: 'white', borderRadius: 10, padding: '10px 12px', marginBottom: 10, boxShadow: '0 4px 10px rgba(15, 23, 42, 0.04)', position: 'relative' }}>
                                    <div style={{ width: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div style={{ width: 28, height: 28, borderRadius: 7, background: '#e6eefb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: '#1e64f2' }}>
                                            {(nameFr(product) || 'P').charAt(0).toUpperCase()}
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flex: '1 1 120px', minWidth: 0 }}>
                                        <div style={{ minWidth: 0, overflow: 'hidden' }}>
                                              <div style={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nameFr(product)}</div>
                                        </div>
                                    </div>


                                    <div style={{ flex: '0 0 110px', minWidth: 0 }}>{getFirst(product, ['Ref','ref','Barcode','barcode','code_barre','codeBarre']) || '-'}</div>
<div style={{ flex: '0 0 120px', minWidth: 0, textAlign: 'center' }}>
  {product.PrixDetail
    ? `${parseFloat(product.PrixDetail).toFixed(2)} ${t('currency')}`
    : '-'}
</div>
                                    <div style={{ flex: '0 0 120px', minWidth: 0, textAlign: 'center' }}>{product.PrixGros ? `${parseFloat(product.PrixGros ).toFixed(2)} ${t('currency')}` : '-'}</div>
                                    <div style={{ flex: '0 0 90px', minWidth: 0, textAlign: 'center', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                                        <div style={{ fontWeight: 700 }}>{qtyOf(product)}</div>
                                        {(() => {
                                            const qty = qtyOf(product);
                                            const threshold = thresholdOf(product);
                                            if (qty <= 0) {
                                                return <div style={{ display: 'inline-flex', alignItems: 'center', background: '#fff0f0', color: '#d9534f', padding: '6px 8px', borderRadius: 20, fontSize: 12 }}><span style={{ width: 10, height: 10, background: '#ff4d4f', borderRadius: '50%', display: 'inline-block', marginRight: 6 }}></span>{t('out_of_stock_label')}</div>
                                            } else if (threshold > 0 && qty <= threshold) {
                                                return <div style={{ display: 'inline-flex', alignItems: 'center', background: '#fff7e6', color: '#d39e00', padding: '6px 8px', borderRadius: 20, fontSize: 12 }}><span style={{ width: 10, height: 10, background: '#ffd43b', borderRadius: '50%', display: 'inline-block', marginRight: 6 }}></span>{t('alert_label')}</div>
                                            } else {
                                                return <div style={{ display: 'inline-flex', alignItems: 'center', background: '#e6fff0', color: '#28a745', padding: '6px 8px', borderRadius: 20, fontSize: 12 }}><span style={{ width: 10, height: 10, background: '#28a745', borderRadius: '50%', display: 'inline-block', marginRight: 6 }}></span>{t('in_stock_label')}</div>
                                            }
                                        })()}
                                    </div>

                                    <div style={{ flex: '0 0 150px', minWidth: 0, display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
                                        <button onClick={() => handleEdit(product.ID)} style={{ borderRadius: 8, background: 'white', border: '1px solid #1e64f2', color: '#1e64f2', padding: '6px 10px', cursor: 'pointer' }}><Edit size={16} /></button>
                                        <button onClick={() => handleDelete(product.ID)} style={{ borderRadius: 8, background: 'white', border: '1px solid #ff4d4f', color: '#ff4d4f', padding: '6px 10px', cursor: 'pointer' }}>  <Trash2 size={16} /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{editingProductId ? t('Modifier_le_produit') : t('ajouter_un_produit')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <div className="d-flex">
                            {/* Left column: image preview and choose button */}
                            <div style={{ width: '35%', paddingRight: '20px' }}>
                                <div style={{ border: '1px solid #e6e6e6', borderRadius: '10px', padding: '16px', textAlign: 'center' }}>
                                    {newProduct.image && typeof newProduct.image === 'string' && (
                                        <img src={`https://plateformewmg.cloud/storage/${newProduct.image}`} alt="product" style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
                                    )}
                                    {newProduct.image && newProduct.image instanceof File && (
                                        <img src={URL.createObjectURL(newProduct.image)} alt="preview" style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
                                    )}
                                    {!newProduct.image && (
                                        <div style={{ width: '100%', height: '160px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f7', borderRadius: '8px' }}>
                                            <div style={{ color: '#9aa0a6' }}>
                                                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 16V8a2 2 0 0 0-2-2h-3V4a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v2H5a2 2 0 0 0-2 2v8" stroke="#9aa0a6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><rect x="3" y="12" width="18" height="8" rx="2" stroke="#9aa0a6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                            </div>
                                        </div>
                                    )}
                                                                        <div className="mt-3">
                                        <label className="btn" style={{ background: '#e9ecef', borderRadius: '8px', padding: '10px 14px', cursor: 'pointer' }}>
                                            {t('Choisir_une_image') || 'Choisir une image...'}
                                            <input type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })} />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Right column: fields in two columns */}
                            <div style={{ width: '65%' }}>
                                <div className="row">
                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                                                                        <Form.Label>{t('Nom_du_produit')}</Form.Label>
                                            <Form.Control type="text" value={newProduct.Name.fr} onChange={(e) => setNewProduct((prev) => ({ ...prev, Name: { ...prev.Name, fr: e.target.value } }))} required />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                                                                        <Form.Label>{t('Code_barre_Ref')}</Form.Label>
                                            <Form.Control type="text" name="barcode" value={newProduct.barcode} onChange={(e) => setNewProduct({ ...newProduct, barcode: e.target.value })} />
                                        </Form.Group>
                                    </div>
<div className="col-6">
  <Form.Group className="mb-3" controlId="formCategoryAdmin">
        <Form.Label>{t('Categorie_Admin')}</Form.Label>
    <Form.Control
      type="text"
      list="category-admin-options"
            placeholder={t('Choisissez_ou_entrez_une_categorie')}
      value={newProduct.CategoryAdmin || ''}
      onChange={(e) =>
        setNewProduct({ ...newProduct, CategoryAdmin: e.target.value })
      }
      required
    />
    <datalist id="category-admin-options">
      {categories.length > 0 ? (
        categories.map((cat, i) => <option key={i} value={cat} />)
      ) : (
        <option disabled value="">
                    {t('Aucune_categorie_disponible')}
        </option>
      )}
    </datalist>
    <Form.Text className="text-muted">
            {t('Categorie_aide')}
    </Form.Text>
  </Form.Group>
</div>


                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Prix_achat')}</Form.Label>
                                            <Form.Control type="number" step="0.01" name="purchase_price" value={newProduct.purchase_price} onChange={(e) => setNewProduct({ ...newProduct, purchase_price: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Prix_Detail')}</Form.Label>
                                            <Form.Control type="number" step="0.01" name="retail_price" value={newProduct.retail_price} onChange={(e) => setNewProduct({ ...newProduct, retail_price: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Prix_Gros')}</Form.Label>
                                            <Form.Control type="number" step="0.01" name="wholesale_price" value={newProduct.wholesale_price} onChange={(e) => setNewProduct({ ...newProduct, wholesale_price: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Prix_Carton')}</Form.Label>
                                            <Form.Control type="number" step="0.01" name="carton_price" value={newProduct.carton_price} onChange={(e) => setNewProduct({ ...newProduct, carton_price: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Pieces_par_Carton')}</Form.Label>
                                            <Form.Control type="number" name="pieces_per_carton" value={newProduct.pieces_per_carton} onChange={(e) => setNewProduct({ ...newProduct, pieces_per_carton: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Stock')}</Form.Label>
                                            <Form.Control type="number" name="StockQuantity" value={newProduct.StockQuantity} onChange={(e) => setNewProduct({ ...newProduct, StockQuantity: e.target.value })} required />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-2">
                                            <Form.Label>{t('Seuil_alerte')}</Form.Label>
                                            <Form.Control type="number" name="alert_threshold" value={newProduct.alert_threshold} onChange={(e) => setNewProduct({ ...newProduct, alert_threshold: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    {/* Description fields removed per request */}

                                </div>
                                <div className="text-end mt-3">
                                    <Button variant="primary" type="submit" disabled={loading}>{loading ? t('loading') : editingProductId ? t('modifier') : t('ajouter')}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </AnimationRevealPage>
    );
};

export default GestionProduits;
